module.exports = __webpack_public_path__ + "static/media/dna_beauty-report.16cd9097.png";